import React from "react";

import { GetEstadoString } from "../../othelloFunciones";

import OthelloComboBox from "../../componentsothello/OthelloComboBox";
import OthelloEdit from "../../componentsothello/OthelloEdit.jsx";
import { TipoEntrega, TiposEntrega} from "../../othelloConstantes.jsx";
import OthelloPrimary from "../../componentsothello/OthelloPrimary";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

function Pedido({...props })
{
    //variables de las propiedas recibidas
    const { idpedido} = props;

    const [pedido, setPedido] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {

        var jsonData = JSON.stringify(idpedido);

        fetch('api/Data/GetPedido', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(data => {
            setPedido(data);
            setLoading(false)
        }).catch(error => {
            setPedido(null);
            setLoading(false)
        });
    }, [loading]);


    let lineas = !loading && pedido != null ? pedido.lineas.map(x => {

        return <div>
            <Grid container lg={12} style={{ marginBottom: 5 }}>                            
                <Grid item lg={7} >
                    <span style={{  fontSize: 13 }}><b>{x.nomArticulo}</b></span>
                </Grid>
                <Grid item lg={1}>                
                    <div style={{ width: 15,  fontSize: 13, textAlign: 'right', alignSelf: 'stretch', marginRight: 0 }}>
                        <b>{x.cantidad}</b>
                    </div>
                </Grid>
                <Grid item lg={2}>
                        <div style={{ width: 58,fontSize: 13, textAlign: 'right', alignSelf: 'stretch', marginRight: 0 }}>
                            <b>{x.precio.toFixed(2)} &euro;</b>
                        </div>           
                </Grid>
                    <Grid item lg={1}>
                <div style={{  width: 58, fontSize: 13, textAlign: 'right', alignSelf: 'stretch', marginRight: 0 }}>
                        <b>{(x.cantidad * x.precio).toFixed(2)} &euro;</b>
                    </div>
                </Grid>
            </Grid>                  
        </div>
    }) : "";

    return (
        <>
            <div>           
                    {!loading && pedido != null ?
                    <div>
                        <OthelloPrimary><span style={{ fontSize: 15 }}><b>Datos del Pedido</b></span></OthelloPrimary>
                        <Grid container>
                            <Grid item xs={3}  >
                                <OthelloEdit label="Pedido" currentvalue={pedido.id_Pedido} readonly={true} />
                            </Grid>
                            <Grid item xs={3}  >                                
                                <OthelloEdit label="Estado" currentvalue={ GetEstadoString(pedido.estado)} readonly={true} />
                            </Grid>
                            <Grid item xs={3}  >
                                <OthelloEdit label="Fecha Pedido" currentvalue={pedido.fechaPedidoString} readonly={true} />
                            </Grid>  
                            <Grid item xs={3}  >
                                <OthelloEdit label="Hora Pedido" currentvalue={pedido.horaPedidoString} readonly={true} />
                            </Grid> 
                        </Grid>                      
                        <Grid container>   
                            <Grid item xs={3} >
                                <OthelloComboBox label="Tipo" currentvalue={pedido.tipoEntrega} disabled={true} items={TipoEntrega} />
                            </Grid> 
                            <Grid item xs={9}  >
                                <OthelloEdit label="Cliente" currentvalue={pedido.nombreApellidos} readonly={true} />
                            </Grid>                                                        
                            <Grid item xs={3}  >
                                <OthelloEdit label="Telefono" currentvalue={pedido.telefono} readonly={true} />
                            </Grid>                                                 
                            <Grid item xs={3}  >
                                <OthelloEdit label="DNI" currentvalue={pedido.dni} readonly={true} />
                            </Grid>
                            <Grid item xs={3}  >
                                <OthelloEdit label="Entrega" currentvalue={pedido.fechaEntregaString} readonly={true} />
                            </Grid>
                            <Grid item xs={3}  >
                                <OthelloEdit label="Hora Entrega" currentvalue={pedido.horaEntregaString} readonly={true} />
                            </Grid>                          
                            <Grid item xs={12}  >
                                <OthelloEdit label="Observaciones" currentvalue={pedido.observaciones} readonly={true} />
                            </Grid>
                        </Grid>
                        {pedido.tipoEntrega == TiposEntrega.EnCasa ?
                            <Grid container>
                                <Grid item xs={12}  >
                                    <OthelloPrimary><span style={{ fontSize: 15 }}><b>Datos del Envio</b></span></OthelloPrimary>
                                </Grid>
                                <Grid item xs={12}  >
                                    <OthelloEdit label="Direccion" currentvalue={pedido.direccionEnvio} readonly={true} />
                                </Grid>
                                <Grid item xs={4} >                                    
                                    <OthelloEdit label="Codigo Postal" currentvalue={pedido.codPostalEnvio} readonly={true} />
                                </Grid>
                                <Grid item xs={4}  >
                                    <OthelloEdit label="Poblacion" currentvalue={pedido.poblacionEnvio} readonly={true} />
                                </Grid>
                                <Grid item xs={4}  >
                                    <OthelloEdit label="Pais" currentvalue={pedido.paisEnvio} readonly={true} />
                                </Grid>                                
                            </Grid> : ""}   
                        <Grid container lg={12} style={{ marginBottom: 5 }}>      
                            <Grid item xs={12}  >
                                <OthelloPrimary><span style={{ fontSize: 15 }}><b>Detalle del Pedido</b></span></OthelloPrimary>
                            </Grid>
                        </Grid>   
                        {lineas}                                        
                        <hr />
                        <Grid container >
                            <Grid item lg={4}>
                                    <span style={{ fontSize: 15 }}><b>Total: </b></span>
                                </Grid>
                            <Grid item lg={8}>
                                <div style={{ fontSize: 15, textAlign: 'right', alignSelf: 'stretch', marginRight: 12 }}>
                                    <b>{pedido.total.toFixed(2)} &euro;</b>
                                </div>
                            </Grid>
                        </Grid>                                                        
                    </div> : ""}                                            
            </div>
        </>
    );
}

export default Pedido;